import {gigaParty} from "./party";

/**
 * example usage: const result: string = await websocketPromise<string>('myKey', {my: 'data'});
 * @param key
 * @param data
 */

export const websocketPromise = <T>(key: string, data?: any): Promise<T> => {
    return new Promise<T>((resolve, reject)  => {
        const id = Math.random().toString(36).substring(7);

        gigaParty.send(JSON.stringify({
            id,
            key: key, // e.g. marco
            data: data | null
        }));

        const messageHandler = (event: MessageEvent) => {
            const message = JSON.parse(event.data)
            if (message.id !== id) return;

            gigaParty.removeEventListener('message', messageHandler);
            resolve(message.data);
        };

        gigaParty.addEventListener('message', messageHandler);
    });
}